<div
    class="tw-h-[405px] md:tw-h-[387px] lg:tw-h-[405px] tw-w-full md:tw-w-[205px] lg:tw-w-[302px] tw-flex tw-flex-col tw-rounded-[15px]"
>
    <div
        class="tw-w-full tw-h-[220px] md:tw-h-[175px] lg:tw-h-[220px] tw-flex tw-justify-center tw-items-center bg-white tw-rounded-t-[15px]"
    >
        <img
            src="{{award.image}}"
            alt="{{award.titleKey | translate}}"
            class="tw-h-[69px] tw-w-[159px] md:tw-h-[55px] md:tw-w-[108px] lg:tw-w-[159px] lg:tw-h-[69px]"
        />
    </div>
    <div
        class="tw-w-full tw-h-[185px] md:tw-h-[212px] lg:tw-h-[185px] tw-pl-[25px] tw-pt-[20px] tw-pr-[73px] tw-pb-[16px] md:tw-pt-[14px] md:tw-pr-[20px] md:tw-pb-[48px] md:tw-pl-[16px] lg:tw-pt-[20px] lg:tw-pr-[43px] lg:tw-pb-[16px] lg:tw-pl-[25px] tw-flex tw-flex-col tw-gap-[16px] tw-bg-gradient-to-b tw-from-stone-300/0 tw-to-neutral-200 tw-rounded-b-[15px]"
    >
        <span class="lg:tw-text-[16px] md:tw-text-[14px] tw-text-[16px] tw-text-[#002D86] tw-font-bold">{{ award.titleKey | translate }}</span>
        <span class="tw-text-[13px] tw-font-normal tw-text-[#2B2B2B]">{{ award.descriptionKey | translate }}</span>
    </div>
</div>
